import * as types from "./types";
import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADD_QUESTIONNAIRE: {
      return [...state, action.payload];
    }
    case types.SET_QUESTION_IMAGE: {
      const { image, questionnaireId, sIdx, qIdx, iIdx } = action.payload;
      const questionnaireIdx = state.findIndex(q => q.id === questionnaireId);
      const questionnaire = state[questionnaireIdx];
      const section = questionnaire.questionnaire_sections[sIdx];
      const question = section.questions[qIdx];
      const imageObj = question.images[iIdx];
      return [
        ...state.slice(0, questionnaireIdx),
        {
          ...questionnaire,
          questionnaire_sections: [
            ...questionnaire.questionnaire_sections.slice(0, sIdx),
            {
              ...section,
              questions: [
                ...section.questions.slice(0, qIdx),
                {
                  ...question,
                  images: [
                    ...question.images.slice(0, iIdx),
                    { ...imageObj, image },
                    ...question.images.slice(iIdx + 1),
                  ],
                },
                ...section.questions.slice(qIdx + 1),
              ],
            },
            ...questionnaire.questionnaire_sections.slice(sIdx + 1),
          ],
        },
        ...state.slice(questionnaireIdx + 1),
      ];
    }
    case types.SET_OPTION_IMAGE: {
      const { image, questionnaireId, sIdx, qIdx, oIdx } = action.payload;
      const questionnaireIdx = state.findIndex(q => q.id === questionnaireId);
      const questionnaire = state[questionnaireIdx];
      const section = questionnaire.questionnaire_sections[sIdx];
      const question = section.questions[qIdx];
      const option = question.options[oIdx];
      return [
        ...state.slice(0, questionnaireIdx),
        {
          ...questionnaire,
          questionnaire_sections: [
            ...questionnaire.questionnaire_sections.slice(0, sIdx),
            {
              ...section,
              questions: [
                ...section.questions.slice(0, qIdx),
                {
                  ...question,
                  options: [
                    ...question.options.slice(0, oIdx),
                    {
                      ...option,
                      image,
                    },
                    ...question.options.slice(oIdx + 1),
                  ],
                },
                ...section.questions.slice(qIdx + 1),
              ],
            },
            ...questionnaire.questionnaire_sections.slice(sIdx + 1),
          ],
        },
        ...state.slice(questionnaireIdx + 1),
      ];
    }
    case types.SET_THANKYOU_IMAGE: {
      const { image, key, questionnaireId } = action.payload;
      const questionnaireIdx = state.findIndex(q => q.id === questionnaireId);
      const questionnaire = state[questionnaireIdx];
      return [
        ...state.slice(0, questionnaireIdx),
        {
          ...questionnaire,
          [key]: image,
        },
        ...state.slice(questionnaireIdx + 1),
      ];
    }
    case types.SET_SURVEY_BACKGROUND: {
      const { background, questionnaireId } = action.payload;
      const questionnaireIdx = state.findIndex(q => q.id === questionnaireId);
      const questionnaire = state[questionnaireIdx];
      return [
        ...state.slice(0, questionnaireIdx),
        {
          ...questionnaire,
          background_image: background,
        },
        ...state.slice(questionnaireIdx + 1),
      ];
    }
    default:
      return state;
  }
};
